import React from "react"

export default class StatisticContainer extends React.Component {
  render() {
    return (
      <div className='statistic'>
        {this.props.children}
      </div>
    )
  }
}
